import React from 'react';
import type { Attachment } from 'components/framework/models';
import styles from './ConversationPanel.module.css';

interface ImagePopoverProps {
  attachment: Attachment;
  onClose: () => void;
}

const ImagePopover: React.FC<ImagePopoverProps> = ({ attachment, onClose }) => {
  return (
    <div className={styles.imagePopoverOverlay} onClick={onClose}>
      <div
        className={styles.imagePopoverContainer}
        onClick={e => e.stopPropagation()}
      >
        <button className={styles.imagePopoverCloseButton} onClick={onClose}>
          ×
        </button>
        <img
          src={attachment.downloadUrl}
          className={styles.imagePopoverImage}
        />
      </div>
    </div>
  );
};

export default ImagePopover;
